import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dedicated-hosting',
  templateUrl: './dedicated-hosting.component.html',
  styleUrls: ['./dedicated-hosting.component.scss']
})
export class DedicatedHostingComponent implements OnInit {

  pt: string = 'pt-70';
  pb: string = 'pb-20'; 
  ptb: string = 'ptb-100'; 
  section: string = 'dedicated-hosting'; 
  title: string = 'Consulta Nuestros Precios Sin Compromiso, Contáctanos.'; 
  constructor() { }
  
  ngOnInit(): void {
  }

}
